<template>
  <v-alert class="pa-0 text-center">Selecione o tipo de ação</v-alert>
</template>
<script>
export default {};
</script>
